module.exports = __webpack_public_path__ + "static/img/running.ae5a953f.jpeg";